"use strict";
exports.__esModule = true;
exports.SliceType = void 0;
var SliceType;
(function (SliceType) {
    SliceType["AnchorList"] = "anchor_list";
    SliceType["ArticleList"] = "article_list";
    SliceType["CardList"] = "card_list";
    SliceType["DownloadLinks"] = "download_links";
    SliceType["Exergue"] = "exergue";
    SliceType["Footnotes"] = "footnotes";
    SliceType["Headnote"] = "headnote";
    SliceType["Heading2"] = "heading_2";
    SliceType["Image"] = "image";
    SliceType["Insert"] = "insert";
    SliceType["Interview"] = "interview";
    SliceType["KeyNumbers"] = "key_numbers";
    SliceType["LargeCardGrid"] = "large_card_grid";
    SliceType["List"] = "list";
    SliceType["Text"] = "text";
    SliceType["TextWithImage"] = "text_with_image";
    SliceType["SliderHero"] = "slider_hero";
    SliceType["PressReleaseList"] = "press_release_list";
    SliceType["TwitterCarousel"] = "twitter_carousel";
    SliceType["VideoHero"] = "video_hero";
})(SliceType = exports.SliceType || (exports.SliceType = {}));
//# sourceMappingURL=slice-type.js.map